import { useEffect, useState } from 'react';
import { useCookieConsent } from '../CookieConsentProvider';
import { LinkedInTag } from '../../utils';
import { linkedin } from '../../config';

export const LinkedInTracking = ({ location }) => {
  const consent = useCookieConsent();

  const [initialized, setInitalized] = useState(false);
  useEffect(() => {
    const setInit = () => setInitalized(true);

    if (consent.status === 'accepted') {
      if (!initialized) {
        LinkedInTag.init(linkedin.id, 'dc', false);
        setInit();
        LinkedInTag.track();
      }
    } else if (consent.status === 'declined') {
      LinkedInTag.init(linkedin.id, 'dc', true);
    }
  }, [
    consent.status,
    location.pathname,
    location.search,
    initialized
  ]);

  return null;
}